import { render } from "./AdminRiderrateEdit.vue?vue&type=template&id=28532cf5&scoped=true&ts=true&lang=true"
import script from "./AdminRiderrateEdit.vue?vue&type=script&lang=ts"
export * from "./AdminRiderrateEdit.vue?vue&type=script&lang=ts"

import "./AdminRiderrateEdit.vue?vue&type=style&index=0&id=28532cf5&scoped=true&lang=css"

import exportComponent from "/var/www/adminold.quickup.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28532cf5"]])

export default __exports__